import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { useTranslation } from "react-i18next";
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Divider,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Stack } from "@mui/system";
import { getAllProducts } from "../../../redux/slices/adminProductsSlice";
import { getAllStores } from "../../../redux/slices/adminStoreSlice";
import Checkbox from "@mui/material/Checkbox";
import CloseIcon from "@mui/icons-material/Close";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import {
  makeReceiptInvalid,
  makeReceiptProcessed,
} from "../../../redux/slices/adminSlice";
import { getAllReceiptsQuery, manualReceiptAdd } from "../../../redux/slices/receiptsSlice";
import { setNotification } from "../../../redux/slices/notificationsSlice";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const AdminProcessReceiptModal = ({
  open,
  onClose,
  receiptToProcess,
  onSuccessUpdateReceipt,
  disableActions,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [store, setStore] = useState();
  const handleOnStoreChange = (event) => {
    setStore(event.target.value);
  };
  const [invoiceNumber, setInvoiceNumber] = useState();
  const [isInvalidReceipt, setIsInvalidReceipt] = useState(false);
  const [totalPoints, setTotalPoints] = useState();
  const [invoiceInvalid, setInvoiceInvalid] = useState(false);

  const getAllProductsLoading = useSelector(
    (state) => state.adminProducts.getAllProductsLoading
  );
  const allDefinedProducts = useSelector(
    (state) => state.adminProducts.allDefinedProducts
  );
  const getAllStoresLoading = useSelector(
    (state) => state.adminStores.getAllStoresLoading
  );
  const allDefinedStores = useSelector(
    (state) => state.adminStores.allDefinedStores
  );
  const makeReceiptInvalidLoading = useSelector(
    (state) => state.admin.makeReceiptInvalidLoading
  );
  const manualReceiptAddLoading = useSelector(
    (state) => state.receipts.manualReceiptAddLoading
  );
  const manualReceptAddError = useSelector(
    (state) => state.receipts.manualReceptAddError
  );
  const makeReceiptProcessedError = useSelector(
    (state) => state.admin.makeReceiptProcessedError
  );
  const customerPointsGot = useSelector(
    (state) => state.admin.customerPointsGot
  );

  const allReceipts = useSelector((state) => state.receipts.allReceipts);

  const [productsFromReceiptFields, setProductsFromReceiptFields] = useState([
    { objectId: "", name: "", qty: "" },
  ]);

  useEffect(() => {
    dispatch(getAllProducts());
    dispatch(getAllStores());
    dispatch(getAllReceiptsQuery());
  }, [dispatch]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (invoiceNumber) {
        checkInvoiceNumberValidation();
      }
    }, 500);
    return () => clearTimeout(timer);
  }, [invoiceNumber]);

  const checkInvoiceNumberValidation = () => {
    setInvoiceInvalid(
      allReceipts.find((r) => r?.attributes?.invoice_number === invoiceNumber)
    );
  };
  const handleOnProductChange = (event, index) => {
    const products = [...productsFromReceiptFields];
    const prodValue = event.target.value;
    products[index].name = prodValue.name;
    products[index].objectId = prodValue.objectId;
    setProductsFromReceiptFields(products);
  };
  const handleOnQtyInputChange = (event, index) => {
    const products = [...productsFromReceiptFields];
    products[index].qty = event.target.value;
    setProductsFromReceiptFields(products);
  };

  const handleOnInvoiceNumberInputChange = (event) => {
    setInvoiceNumber(event.target.value);
  };
  const onSelectInvalidReceipt = (event) => {
    setIsInvalidReceipt(event.target.checked);
  };
  useEffect(() => {
    calculatePoints();
  }, [productsFromReceiptFields]);

  const onAddProductField = () => {
    const allFields = [...productsFromReceiptFields];
    allFields.push({ objectId: "", name: "", qty: "" });
    setProductsFromReceiptFields(allFields);
  };
  const onRemoveProductField = (i) => {
    const allFields = productsFromReceiptFields.filter(
      (f, index) => i !== index
    );
    setProductsFromReceiptFields(allFields);
  };

  const calculatePoints = () => {
    if (productsFromReceiptFields[0].name && productsFromReceiptFields[0].qty) {
      let points = 0;
      productsFromReceiptFields.forEach((productReceipt) => {
        allDefinedProducts.forEach((product) => {
          if (productReceipt.objectId === product.objectId) {
            points += product.points * parseInt(productReceipt.qty);
          }
        });
      });
      setTotalPoints(points);
    } else {
      setTotalPoints(0);
    }
  };
  const onSave = () => {
    if (isInvalidReceipt) {
      dispatch(
        makeReceiptInvalid({
          objectId: receiptToProcess.objectId,
          processed: true,
          valid: false,
        })
      ).then(
        (response) => {
          onSuccessUpdateReceipt();
        },
        (error) => {
          console.log("error", error);
        }
      );
    } else {
      dispatch(
        manualReceiptAdd({
          invoice_number: invoiceNumber,
          store,
          products: productsFromReceiptFields,
          username: receiptToProcess.username,
        })
      ).then(
        (response) => {
          dispatch(
            makeReceiptProcessed({
              objectId: receiptToProcess.objectId,
              processed: true,
            })
          ).then(
            () => {
              onSuccessUpdateReceipt(response.payload.current_points);
            },
            (error) => {
              dispatch(
                setNotification({
                  show: true,
                  message: makeReceiptProcessedError,
                  severity: "error",
                })
              );
            }
          );
        },
        (error) => {
          dispatch(
            setNotification({
              show: true,
              message: manualReceptAddError,
              severity: "error",
            })
          );
        }
      );
    }
  };
  const isFormValid = () => {
    return (
      isInvalidReceipt ||
      (invoiceNumber && store && productsFilled() && !invoiceInvalid)
    );
  };
  const productsFilled = () => {
    let isValid = true;
    productsFromReceiptFields.forEach((p) => {
      isValid = p.qty && p.name;
    });
    return isValid;
  };

  function storeSelect() {
    return (
      <Grid display="flex" alignItems="center">
        <Stack marginTop="12px" minWidth="250px">
          <InputLabel id="demo-simple-select-label">
            {t("processReceiptModal.store")}
          </InputLabel>
          <Select
            disabled={isInvalidReceipt}
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={store}
            onChange={handleOnStoreChange}
          >
            {allDefinedStores?.map((store) => {
              return <MenuItem value={store}>{store.name}</MenuItem>;
            })}
          </Select>
        </Stack>
      </Grid>
    );
  }
  function productsSelect(productReceipt, index) {
    return (
      <Stack display="flex" alignItems="end" direction="row">
        <Stack marginTop="12px" minWidth="200px">
          <InputLabel id="demo-simple-select-label">
            {t("processReceiptModal.articleWithNum", { num: index + 1 })}
          </InputLabel>
          <Select
            disabled={isInvalidReceipt}
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={productReceipt.product}
            onChange={(e) => handleOnProductChange(e, index)}
          >
            {allDefinedProducts?.map((product) => {
              return <MenuItem value={product}>{product.name}</MenuItem>;
            })}
          </Select>
        </Stack>
        <Stack marginTop="35px" marginLeft="8px" maxWidth="100px">
          <TextField
            disabled={isInvalidReceipt}
            id="qty"
            label={t("processReceiptModal.qty")}
            type="number"
            value={productReceipt.qty}
            onChange={(e) => handleOnQtyInputChange(e, index)}
            required
          ></TextField>
        </Stack>
        {index === productsFromReceiptFields.length - 1 && (
          <Stack display="flex" direction="row">
            <IconButton
              disabled={isInvalidReceipt}
              aria-label="add"
              onClick={onAddProductField}
            >
              <AddCircleIcon />
            </IconButton>
            {index > 0 && (
              <IconButton
                disabled={isInvalidReceipt}
                aria-label="delete"
                onClick={() => onRemoveProductField(index)}
              >
                <RemoveCircleIcon />
              </IconButton>
            )}
          </Stack>
        )}
      </Stack>
    );
  }
  function productsAdding() {
    return (
      <Stack>
        {productsFromReceiptFields.map((product, index) => {
          return productsSelect(product, index);
        })}
      </Stack>
    );
  }

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={onClose}
      aria-describedby="alert-dialog-slide-description"
      maxWidth="1000px"
    >
      <Box width="1000px" padding="24px">
        <Stack direction="row" display="flex" justifyContent="end">
          <IconButton aria-label="delete" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Stack>
        <DialogTitle>
          {t(
            disableActions
              ? "processReceiptModal.reviewReceipt"
              : "processReceiptModal.title"
          )}
        </DialogTitle>
        <Stack direction="row">
          <div className="img-container">
            <img
              width="550px"
              src={receiptToProcess.picture.url}
              alt="receipt"
            />
          </div>
          <Stack
            direction="column"
            sx={{
              opacity: disableActions ? 0.3 : 1,
              pointerEvents: disableActions ? "none" : "all",
            }}
          >
            <Stack
              spacing={2}
              padding="8px"
              alignItems="center"
              direction="row"
              justifyContent="center"
            >
              <Alert severity="info">
                {t("processReceiptModal.processReceiptHint")}
              </Alert>
            </Stack>
            <Stack>
              <Typography>
                {t("processReceiptModal.user", {
                  name: receiptToProcess.username,
                })}
              </Typography>
            </Stack>
            <Stack
              display="flex"
              alignItems="center"
              direction="row"
              marginLeft="-12px"
              paddingTop="24px"
            >
              <Checkbox
                checked={isInvalidReceipt}
                onChange={onSelectInvalidReceipt}
              />
              <Typography>{t("processReceiptModal.invalidReceipt")}</Typography>
            </Stack>
            <Stack marginTop="24px" maxWidth="250px">
              <InputLabel id="demo-simple-select-label">
                {t("processReceiptModal.invoiceNumber")}
              </InputLabel>
              <TextField
                disabled={isInvalidReceipt}
                id="invoiceNumber"
                type="text"
                value={invoiceNumber}
                onChange={handleOnInvoiceNumberInputChange}
                required
                error={invoiceInvalid}
                helperText={
                  invoiceInvalid ? t("errors.invoiceNumberSubmitted") : ""
                }
              ></TextField>
            </Stack>
            {getAllStoresLoading === "PENDING" ? (
              <CircularProgress />
            ) : (
              storeSelect()
            )}
            <Stack padding="12px 0" direction="column">
              <Typography>Proizvodi</Typography>
              <Divider />
            </Stack>
            {getAllProductsLoading === "PENDING" ? (
              <CircularProgress />
            ) : (
              productsAdding()
            )}

            {totalPoints > 0 && (
              <Stack marginTop="12px">
                <Alert severity="info">
                  {t("processReceiptModal.totalPoints", {
                    totalPoints: totalPoints,
                  })}
                </Alert>
              </Stack>
            )}
          </Stack>
        </Stack>
        <Stack
          display="flex"
          direction="row"
          justifyContent="end"
          marginTop="12px"
        >
          <Button onClick={onClose} variant="text">
            {t("processReceiptModal.cancel")}
          </Button>
          <Button
            disabled={!isFormValid()}
            onClick={onSave}
            variant="contained"
          >
            {makeReceiptInvalidLoading === "PENDING" ||
            manualReceiptAddLoading === "PENDING" ? (
              <CircularProgress />
            ) : (
              t("processReceiptModal.save")
            )}
          </Button>
        </Stack>
      </Box>
    </Dialog>
  );
};

export default AdminProcessReceiptModal;
